module.exports = __webpack_public_path__ + "img/star-big-purple.3f50e176.png";